export default __webpack_public_path__ + "static/media/chevron_bottom.c88b2724.svg";